import {Navbar,Footer} from '../components';
import {useParams} from 'react-router-dom';
import {useState,useEffect} from 'react';
import axios from "axios";
import configData from "../config.json";
import * as Icon from 'react-bootstrap-icons';
import { closestToWithOptions } from 'date-fns/fp';

function OverheadLinkUp(){
    if(localStorage.getItem('branchID')===null){
        window.location.replace('/');
    }

  const [overheadList,setOverheadList]=useState([]);
  const [expCompList,setExpCompList]=useState([]);
  const [inputData,setInputData]=useState([]);

  const getOverheadList = async () => {
        const response=await axios.get(configData.SERVER_URL+`/overheadList`)
        setOverheadList(response.data.OverheadData);
        setExpCompList(response.data.expComData);
    };

  useEffect(() => {
    getOverheadList();

  }, []);

  const handleInput=async(e)=>{
        const {name,value}=e.target; 
        setInputData({...inputData,[name]:value});  
    }

    const handleSubmit =async(e) => {
        e.preventDefault(); 
        try {
            let res=await axios.post(configData.SERVER_URL+`/overheadAssign`,inputData);
            if(res.status===200){
                alert(res.data.message);
                getOverheadList();
            } 
            } catch (error) {
            console.error('System error:', error);
        } 
    };

    async function setExpenseID(id){
        
        try {
            let res=await axios.post(configData.SERVER_URL+`/overheadAssign/${id}/${inputData.subOverheadID}`,);
            if(res.status===200){
                alert(res.data.message);
                getOverheadList();
            } 
            } catch (error) {
            console.error('System error:', error);
        } 
    }


  return(
    <>
    <div className='container'>
    <Navbar />

    <form onSubmit={handleSubmit}  style={{paddingTop:'50px'}}>
    <div className='card'>
        <div className='card-header bg-success'>Overhead LinkUp</div>
        <div className='card-body'>
            
            <div className="col-lg-6 my-3">
            <label>Select Overhead</label>                           
            <select className="form-select" id="subOverheadID" name="subOverheadID" value={inputData.subOverheadID} onChange={(e)=>{handleInput(e)}} required>
            {overheadList.map(data => (
            <option key={data.subOverheadID} value={data.subOverheadID}>{data.overheadName} : {data.subOverheadName}</option>
            ))}
            </select>
            </div>

            <div className="col-lg-6"><span style={{color:'red'}}>LinkUp With<Icon.ArrowDown/></span></div>

            {/* <div className="col-lg-6 my-3">
            <label>Exp. Components</label>                           
            <select className="form-select" id="id" name="id" value={inputData.id} onChange={(e)=>{handleInput(e)}} required>
            {expCompList.map(data => (
            <option key={data.id} value={data.id}>{data.description} : {data.subOverheadName}</option>
            ))}
            </select>
            </div> */}

            {/* <button className='btn btn-info' type="submit">Assign</button> */}

        </div>
    </div>
        
    </form>

    <div className='card'>
        <div className='card-body'>
            <div className='card-header bg-info'>Overhead details</div>
            <div className="table-responsive">
                <table class="table table-success table-hover table-bordered">
                    <thead>
                    <tr>
                        <th>SL No.</th>
                        <th>Head</th>
                        <th>Sub-Head</th>
                        <th>Descriptions</th>
                        <th></th>
                    </tr>
                    </thead>
                    <tbody>
                    {
                    expCompList && expCompList.length>0 && expCompList.map((data,index)=>
                    <tr align="right" key={data.id} >
                        <td align="left">{index+1}</td>   
                        <td align="left">{data.overheadName}</td>
                        <td align="left">{data.subOverheadName}</td>
                        <td align="left">{data.description}</td>
                        <td><button className='btn btn-info'><Icon.ArrowRight onClick={() => {setExpenseID(data.id);}}/></button></td>
                    </tr>
                    )}
                    </tbody>
                </table>
            </div>
        </div>
    </div>

    <Footer/>
    </div>
    </>
  )
}

export default OverheadLinkUp;